import React from 'react';
import { Route } from 'react-router-dom';
import TeamRoutes from './Team/routes';
const routes = () => [<TeamRoutes key="TeamRoutes" />];

const TeamRoute = () => <Route component={routes} />;

export default TeamRoute;



// WEBPACK FOOTER //
// src/modules/screens/team/routes.js